var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',{staticClass:"app-dropdown-item",on:{"click":_vm.onClick}},[(_vm.icon)?_c('div',{staticClass:"icon"},[_c('span',{staticClass:"material-icons"},[_vm._v(" "+_vm._s(_vm.icon)+" ")])]):_vm._e(),_vm._t("default")],2)}
var staticRenderFns = []

export { render, staticRenderFns }